import React from 'react';
import { TrendingUp, MapPin, Users, Shield, Zap, DollarSign, Factory, Plane, Home, Leaf, CheckCircle } from 'lucide-react';

const InvierteYucatan = () => {
  const ventajasCompetitivas = [
    {
      icono: MapPin,
      titulo: 'Ubicación Estratégica',
      descripcion: 'Punto de conexión entre México, Estados Unidos, Centroamérica y el Caribe. Acceso a mercados de más de 500 millones de consumidores.'
    },
    {
      icono: Shield,
      titulo: 'Estabilidad y Seguridad',
      descripcion: 'Uno de los estados más seguros de México con bajo índice de criminalidad. Clima de negocios estable y confiable.'
    },
    {
      icono: Users,
      titulo: 'Capital Humano Calificado',
      descripcion: 'Mano de obra especializada y bilinge. Universidades de prestigio y centros de capacitación técnica.'
    },
    {
      icono: Zap,
      titulo: 'Infraestructura Moderna',
      descripcion: 'Aeropuerto internacional, puertos marítimos, carreteras federales y acceso a energía competitiva.'
    },
    {
      icono: TrendingUp,
      titulo: 'Crecimiento Económico',
      descripcion: 'PIB estatal en constante crecimiento. Líder en turismo, manufactura y agroindustria.'
    },
    {
      icono: DollarSign,
      titulo: 'Incentivos Fiscales',
      descripcion: 'Programas de apoyo gubernamental, reducción de impuestos y facilidades para inversionistas extranjeros.'
    }
  ];

  const oportunidadesInversion = [
    {
      sector: 'Turismo Sostenible',
      icono: Plane,
      descripcion: 'Desarrollo de hoteles ecológicos, tours culturales y gastronomía regional.',
      potencial: 'Alto',
      inversion: 'Desde $500,000 USD',
      color: 'from-[#8B1538] to-[#6B0F2A]'
    },
    {
      sector: 'Manufactura Avanzada',
      icono: Factory,
      descripcion: 'Industria automotriz, aeroespacial, textil y de componentes electrónicos.',
      potencial: 'Muy Alto',
      inversion: 'Desde $1,000,000 USD',
      color: 'from-[#8B1538] to-[#6B0F2A]'
    },
    {
      sector: 'Agroindustria',
      icono: Leaf,
      descripcion: 'Producción de miel, cítricos, hortalizas y procesamiento de alimentos.',
      potencial: 'Alto',
      inversion: 'Desde $300,000 USD',
      color: 'from-[#8B1538] to-[#6B0F2A]'
    },
    {
      sector: 'Bienes Raíces',
      icono: Home,
      descripcion: 'Desarrollos residenciales, comerciales e industriales en zonas de alto crecimiento.',
      potencial: 'Muy Alto',
      inversion: 'Desde $800,000 USD',
      color: 'from-[#8B1538] to-[#6B0F2A]'
    }
  ];

  const incentivos = [
    'Reducción de hasta 50% en impuestos estatales durante los primeros 3 años',
    'Exención de derechos de trámites y permisos',
    'Apoyo en la gestión de permisos y licencias',
    'Acceso preferente a financiamiento y créditos',
    'Capacitación gratuita de personal',
    'Terrenos en parques industriales a precios preferenciales'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A]" />
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZ3JpZCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLW9wYWNpdHk9IjAuMSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-20" />
        
        <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center text-white">
            <h1 className="text-5xl font-bold mb-6">Invierte en Yucatán</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto mb-8">
              Descubre las oportunidades de inversión en uno de los estados con mayor crecimiento económico de México
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <button className="px-8 py-3 bg-white text-[#8B1538] rounded-lg hover:bg-gray-100 transition-colors font-medium">
                Descargar Guía de Inversión
              </button>
              <button className="px-8 py-3 bg-transparent border-2 border-white text-white rounded-lg hover:bg-white/10 transition-colors font-medium">
                Contactar Asesor
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Por Qué Yucatán */}
        <section className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">¿Por Qué Invertir en Yucatán?</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Descubre las ventajas que hacen de Yucatán el destino ideal para tu inversión
            </p>
          </div>

          {/* Ubicación Estratégica */}
          <div className="mb-16">
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="p-8 lg:p-12">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                    <MapPin className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6">Ubicación Estratégica</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    Yucatán se posiciona como un punto de conexión privilegiado entre México, Estados Unidos, Centroamérica y el Caribe. 
                    Nuestra ubicación geográfica ofrece acceso directo a mercados que representan más de 500 millones de consumidores.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Con puerto marítimo de altura en Progreso y aeropuerto internacional en Mérida, facilitamos las operaciones de 
                    comercio exterior y la conectividad con los principales centros económicos del continente.
                  </p>
                </div>
                <div className="h-80 lg:h-auto">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_gobierno-moderno/artifacts/fn80vf17_dorian-d1-KG9JL_DL-og-unsplash.jpg"
                    alt="Ubicación Estratégica de Yucatán"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Infraestructura */}
          <div className="mb-16">
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="order-2 lg:order-1 h-80 lg:h-auto">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_gobierno-moderno/artifacts/y9vpnyjp_estefania-cortes-WBVRnm1vivU-unsplash.jpg"
                    alt="Infraestructura de Yucatán"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="order-1 lg:order-2 p-8 lg:p-12">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                    <Zap className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6">Infraestructura de Clase Mundial</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    Contamos con una red de carreteras federales en excelente estado que conectan eficientemente todo el territorio 
                    estatal y facilitan el transporte de mercancías hacia los principales mercados del país.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Los parques industriales modernos ofrecen servicios completos de energía eléctrica confiable, agua, 
                    telecomunicaciones de alta velocidad y seguridad perimetral, garantizando las condiciones óptimas para 
                    operaciones de manufactura y logística de alto nivel.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Calidad de Vida */}
          <div className="mb-16">
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="p-8 lg:p-12">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                    <Users className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6">Calidad de Vida Excepcional</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    Yucatán es reconocido como uno de los estados más seguros de México, ofreciendo un ambiente de tranquilidad 
                    y estabilidad social que favorece el establecimiento de familias y el desarrollo de negocios.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Nuestra rica oferta cultural, patrimonio histórico mundial, gastronomía reconocida internacionalmente, 
                    y cercanía a playas paradisíacas hacen de Yucatán un lugar ideal para vivir y trabajar. 
                    La ciudad de Mérida cuenta con servicios de salud de primer nivel, educación de calidad y una creciente 
                    comunidad internacional.
                  </p>
                </div>
                <div className="h-80 lg:h-auto">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_gobierno-moderno/artifacts/k75yu6oq_hunter-newton-BgZFS8DPg0I-unsplash.jpg"
                    alt="Calidad de Vida en Yucatán"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Fuerza Laboral */}
          <div className="mb-16">
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="order-2 lg:order-1 h-80 lg:h-auto">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_gobierno-moderno/artifacts/yg1wod8b_ivan-cervantes-QwGtlGgQ02w-unsplash.jpg"
                    alt="Fuerza Laboral de Yucatán"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="order-1 lg:order-2 p-8 lg:p-12">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                    <Users className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6">Talento Humano Calificado</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    Yucatán cuenta con una fuerza laboral joven, calificada y comprometida. Las principales universidades del estado 
                    gradúan anualmente miles de profesionistas en ingenierías, tecnologías de la información, administración y otras 
                    áreas clave para la industria moderna.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Además, contamos con centros de capacitación técnica y programas de vinculación empresa-escuela que garantizan 
                    la formación continua del personal según las necesidades específicas de cada sector. La cultura laboral yucateca 
                    se caracteriza por su compromiso, estabilidad y excelente nivel de bilingüismo.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Sector Automotriz */}
          <div className="mb-16">
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="p-8 lg:p-12">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                    <Factory className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6">Sector Automotriz en Expansión</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    Yucatán se ha consolidado como un importante polo de la industria automotriz en México. Empresas líderes mundiales 
                    han elegido nuestro estado para establecer plantas de manufactura de componentes automotrices de alta tecnología.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    El clúster automotriz yucateco ofrece una cadena de suministro integrada, apoyo gubernamental especializado, 
                    y una red de proveedores certificados. La cercanía con Estados Unidos y los tratados comerciales vigentes 
                    facilitan la exportación y competitividad en el mercado norteamericano.
                  </p>
                </div>
                <div className="h-80 lg:h-auto">
                  <img 
                    src="https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=1920&q=80"
                    alt="Sector Automotriz"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Energías Renovables */}
          <div className="mb-16">
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="order-2 lg:order-1 h-80 lg:h-auto">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_gobierno-moderno/artifacts/6d8acpfc_matt-hanns-schroeter-rwYdurKPJf0-unsplash.jpg"
                    alt="Energías Renovables en Yucatán"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="order-1 lg:order-2 p-8 lg:p-12">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                    <Leaf className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6">Líder en Energías Renovables</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    Yucatán está a la vanguardia en generación de energía limpia en México. Contamos con múltiples parques 
                    eólicos y solares que aprovechan las condiciones climáticas privilegiadas de la península.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Las empresas que se establecen en Yucatán pueden acceder a energía renovable a costos competitivos, 
                    cumpliendo con sus objetivos de sustentabilidad y reducción de huella de carbono. 
                    El gobierno estatal promueve activamente proyectos de energía limpia con incentivos especiales y 
                    agilización de trámites para inversiones en este sector estratégico.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Incentivos */}
        <section className="mb-20">
          <div className="bg-gradient-to-br from-slate-100 to-gray-200 rounded-xl p-8 lg:p-12 border border-gray-200">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Incentivos y Apoyos</h2>
              <p className="text-gray-600 max-w-3xl mx-auto">
                El Gobierno de Yucatán ofrece múltiples beneficios para impulsar tu inversión
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
              {incentivos.map((incentivo, index) => (
                <div key={index} className="flex items-start gap-3 bg-white rounded-lg p-4">
                  <CheckCircle className="h-6 w-6 text-[#8B1538] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">{incentivo}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Oportunidades de Inversión */}
        <section className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Oportunidades de Inversión</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Sectores estratégicos con alto potencial de retorno
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {oportunidadesInversion.map((oportunidad, index) => {
              const IconComponent = oportunidad.icono;
              return (
                <div
                  key={index}
                  className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all duration-300"
                >
                  <div className={`bg-gradient-to-r ${oportunidad.color} p-6`}>
                    <div className="flex items-center gap-4">
                      <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                        <IconComponent className="h-8 w-8 text-white" />
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-white">
                          {oportunidad.sector}
                        </h3>
                        <div className="flex items-center gap-4 mt-2">
                          <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium text-white">
                            Potencial: {oportunidad.potencial}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <p className="text-gray-600 mb-4">
                      {oportunidad.descripcion}
                    </p>
                    <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                      <div>
                        <div className="text-sm text-gray-500 mb-1">Inversión Mínima</div>
                        <div className="text-lg font-bold text-[#8B1538]">
                          {oportunidad.inversion}
                        </div>
                      </div>
                      <button className="px-6 py-2 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium">
                        Más Información
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* CTA Section */}
        <section>
          <div className="bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">¿Listo para Invertir en Yucatán?</h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Nuestro equipo de expertos está listo para asesorarte en cada paso de tu inversión
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <button className="px-8 py-3 bg-white text-[#8B1538] rounded-lg hover:bg-gray-100 transition-colors font-medium">
                Agendar Reunión
              </button>
              <button className="px-8 py-3 bg-transparent border-2 border-white text-white rounded-lg hover:bg-white/10 transition-colors font-medium">
                Ver Casos de Éxito
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default InvierteYucatan;